<div class="w-[1200px]">
  <h2 class="font-semibold mb-4">Маршрут</h2>
  <div class="my-2 relative">
    <google-map
      [mapId]="googleMapService.mapId"
      width="100%"
      height="400px"
      [options]="(options$ | async)!"
    >
      @if (directionsResults$ | async; as directionsResults) {
        <map-directions-renderer
          [options]="{ suppressMarkers: true }"
          [directions]="directionsResults"
        />
      }

      @for (
        point of pointsWithMarkers$ | async;
        track point.position.lat + '-' + point.position.lng
      ) {
        <map-advanced-marker
          [position]="point.position"
          [options]="point.markerOptions"
          #marker="mapAdvancedMarker"
        />
      }
    </google-map>
    <div
      class="absolute glass-effect bottom-1 left-1 px-2 py-1 font-semibold rounded-xl"
    >
      {{ routeLength$ | async }}КМ
    </div>
  </div>
  <div class="flex gap-x-2 flex-wrap">
    @for (part of routePartsLength$ | async; track part.route) {
      <div class="flex items-center gap-x-2">
        <tui-badge
          status="error"
          [value]="(part.route | uppercase) + ' ' + part.length"
        ></tui-badge>
      </div>
    }
  </div>
  <div class="flex justify-between"></div>
</div>
